import React from "react";

const items = [
  "GST Filing",
  "ITR",
  "Tax Advisory",
  "ROC Compliance",
  "Accounting",
  "TDS",
  "Payroll",
  "Audit Support",
  "Tumakuru Karnataka",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div
      className="relative overflow-hidden border-y border-border bg-foreground py-5 text-background"
      data-testid="marquee"
    >
      <div className="flex animate-marquee whitespace-nowrap">
        {row.map((t, i) => (
          <div key={i} className="mx-8 flex items-center gap-8">
            <span className="font-[Outfit] text-2xl font-bold uppercase tracking-widest md:text-3xl">
              {t}
            </span>
            <span className="inline-block h-2 w-2 rounded-full bg-primary" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
